module.exports = __webpack_public_path__ + "img/sba.b73ea623.png";